import React, { Component } from 'react';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import withFetch from './withFetch';
import { API_URL } from '../config';

const Container = (WrappedComponent) => {
    class WithSearch extends Component {

        constructor(props) {
            super();

            this.state = {
                isLoading: true,
                locationHandler: {},
            }

            this.form = React.createRef();
        }

        async requestInitialData(params) {
            const allParams = {
                ...params,
                ...WithSearch.addPaginationParams(params),
                returnfacets: true,
                returncompletefacets: true
            }
            delete allParams.page;
            const res = await this.props.fetch(API_URL(`/units/search`, queryString.stringify(allParams))); 
            if (!res.ok) {
                //handle 404
            }
            return await res.json();
        }

        static addPaginationParams(params) {
            const currentPage = isNaN(parseInt(params.page)) ? 1 : parseInt(params.page);
            if (params.page) {
                return {
                    skip: (currentPage-1)*10,
                    take: 10
                };
            }  

            return {
                take: 10
            };
        }

        getFormData(form) {
            const data = new FormData(form);
            let query = '';
            data.forEach((value, key) => { 
                if (value) {
                    query = query + `&${key}=${encodeURIComponent(value)}`;
                }
            });
    
            return queryString.parse(query);
        }

        async handleSubmit(e) {
            e.preventDefault();
            const formDataObj = this.getFormData(e.target);
    
            //Merge forms
            this.props.history.push(`${this.props.location.pathname}?${queryString.stringify(formDataObj)}`);
        }

        async componentDidMount() {
            this.setState({
                isLoading: true
            });

            const { location } = this.props;
            const qs = queryString.parse(location.search);

            const search = await this.requestInitialData(qs);
            this.setState({
                isLoading:false,
                ...search,
                locationHandler: location
            });            
        }

        async componentDidUpdate(prevProps, prevState) {
            if (prevProps && prevProps.location.search !== this.props.location.search) {
                this.setState({
                    isLoading: true,                
                });
                    
                const { location } = this.props;
                const prevLocation = prevProps.location;
                const qs = queryString.parse(location.search);
                const prevQs = queryString.parse(prevLocation.search);
                
                //DO SEARCH
                const search = await this.requestInitialData(qs);

                if (qs.page !== prevQs.page) {
                    
                    if (typeof window !== 'undefined') {
                        window.scrollTo(0, 0);

                        //Hack trigger windows resize for google maps
                        if (typeof(Event) === 'function') {
                            // modern browsers
                            window.dispatchEvent(new Event('resize', { bubbles:true  }));
                        } else {
                            // for IE and other old browsers
                            // causes deprecation warning on modern browsers
                            var evt = window.document.createEvent('UIEvents'); 
                            evt.initUIEvent('resize', true, false, window, 0); 
                            window.dispatchEvent(evt);
                        }
                    }
                    
                }

                this.setState({
                    isLoading:false,
                    ...search,
                    locationHandler: location
                });

                
            }
        }

        submitForm(e, onlyPostParam) {

            if (onlyPostParam) {
                const data = new FormData(this.form.current);
                const param = data.get(onlyPostParam);
                const { location } = this.props;
                const qs = queryString.parse(location.search);
                
                if (!param) {
                    delete qs[onlyPostParam];
                }
                
                const searchQuery = param ? {
                    ...qs,
                    [onlyPostParam]: param
                } : {
                    ...qs
                };

                this.props.history.push(`${this.props.location.pathname}?${queryString.stringify(searchQuery)}`);
            } else {
                this.form.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles:true  }));
            }
        }

        render() {
            const { locationHandler } = this.state;
            return (
                <form ref={this.form} method="get" action="/search" onSubmit={(e) => this.handleSubmit(e)}>
                    <WrappedComponent {...this.props} search={this.state} locationHandler={locationHandler} submitForm={(e, param) => this.submitForm(e, param)} form={this.form} />
                </form>
            );
        }
    };

    return withRouter(withFetch(WithSearch));
};

export default Container;